import { useEffect, useState } from 'react';
import { MsalAuthenticationTemplate } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';

import { loginRequest, protectedResources } from "../authConfig";
import useFetchWithMsal from '../hooks/useFetchWithMsal';

const DashboardContent = () => {
    const { error, execute } = useFetchWithMsal({
        scopes: protectedResources.apiCompanies.scopes.read,
    });

    const [companiesList, setCompaniesList] = useState(null);

    useEffect(() => {
        if (!companiesList) {
            execute("GET", protectedResources.apiCompanies.endpoint).then((response) => {
                setCompaniesList(response);
            });
        }
    }, [execute, companiesList])

    if (error) {
        return <div>Error: {error.message}</div>;
    }

    return <>{companiesList ? companiesList.map(company => <h3>{company.name}</h3>) : null}</>;
};

/**
 * The `MsalAuthenticationTemplate` component will render its children if a user is authenticated
 * or attempt to sign a user in. Just provide it with the interaction type you would like to use
 * (redirect or popup) and optionally a request object to be passed to the login API, a component to display while
 * authentication is in progress or a component to display if an error occurs. For more, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/getting-started.md
 */
export const Dashboard = () => {
    const authRequest = {
        ...loginRequest,
    };

    return (
        <MsalAuthenticationTemplate 
            interactionType={InteractionType.Redirect} 
            authenticationRequest={authRequest}
        >
            <DashboardContent />
        </MsalAuthenticationTemplate>
    );
};
